export const SITE_TITLE = "Idea book: design patterns for USWDS sites";
export const SITE_DESCRIPTION =
  "An idea book of common design patterns for USWDS sites with examples and implementation hints.";
export const SOCIAL_IMAGE_PATH = "/assets/images/social-card.png";
